export default {
    confirmSaveModal: {
        title: 'Confirm save',
        totalVolume: 'Total volume (sum of bins):',
        daysWithEdits: 'Days with edits since last save: {count}',
        atomicWrite: 'This is an atomic write — all {count} bin values will be committed in one transaction.',
        saving: 'Saving...',
        confirmSave: 'Confirm & Save',
        saveFailed: 'Save failed',
        notLoaded: 'Contract not loaded — refresh and try again.',
        savedToast: 'Saved {count} days · {volume}',
    },
}
